__turbopack_context__.v({
  "mediaIcon": "ProfileDetail-module-scss-module__8iqzzq__mediaIcon",
  "tag": "ProfileDetail-module-scss-module__8iqzzq__tag",
});
